var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpt1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bolita 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.111486%",
    y1: "35.882568%",
    x2: "42.4525333%",
    y2: "83.7889099%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D7D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 18,
    cy: 18,
    r: 18
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desarrollo-Juego",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 6,
    transform: "translate(-754, -29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bolita-1",
    transform: "translate(754, 29)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    mask: "url(#mask-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3, 2)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.104404463,32.9028034 C1.55541385,32.3034247 8.43600674,29.2741322 13.5821493,22.0140897 L25.679095,19.0900935 C26.303185,18.9253993 25.824716,19.4248816 25.824716,19.4248816 C23.6169974,21.8142968 13.046472,32.5059175 0.104404463,33 C0.104404463,33 -0.132229684,33 0.107004839,32.9001035",
    fill: "#CEE599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97261836,31.7121457 C18.0443933,26.1962414 23.1229261,11.8732495 23.6846072,10.1534105 C23.6846072,10.1534105 23.7548173,9.96441724 23.5987948,10.0697135 L12.5940067,16.9355699 C10.1808585,25.221576 3.93215682,30.7914784 2.89980785,31.6662473 C2.89980785,31.6662473 2.74638571,31.7931428 2.97001798,31.7094458",
    fill: "#84BD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96825063,28.7098522 C6.43631818,27.7378867 9.67638573,20.5912402 8.08755646,11.9974451 C8.08755646,11.9974451 7.97313995,11.3629676 8.40220186,10.8877845 L18.6918867,0.104367046 C18.9467235,-0.152123855 18.8895152,0.144865609 18.8895152,0.144865609 C18.5176616,2.58557902 15.6338454,19.8163677 6.01245701,28.7314514 C6.01245701,28.7314514 5.90064088,28.8529471 5.96825063,28.7098522",
    fill: "#D81925"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpt1);
export default __webpack_public_path__ + "static/media/opt1.97039cf685c7a23f97ea5d26999d4b9f.svg";
export { ForwardRef as ReactComponent };